import { render } from "./TestNavigation.vue?vue&type=template&id=d5c44026&scoped=true"
import script from "./TestNavigation.vue?vue&type=script&lang=js"
export * from "./TestNavigation.vue?vue&type=script&lang=js"

import "./TestNavigation.vue?vue&type=style&index=0&id=d5c44026&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5c44026"]])

export default __exports__